(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSlider(slider) {
    if (slider.dataset.bound === 'true') return;
    slider.dataset.bound = 'true';

    var before = slider.querySelector('[data-ba-before]');
    var handle = slider.querySelector('[data-ba-handle]');
    var hint = slider.querySelector('.ba-slider__hint');
    var labelBefore = slider.querySelector('.ba-slider__label--before');
    var labelAfter = slider.querySelector('.ba-slider__label--after');
    if (!before || !handle) return;

    var position = 50;
    var isDragging = false;
    var hasInteracted = false;

    // Thresholds: con qué % de slider el label opuesto se desvanece
    var HIDE_AFTER_AT  = 88;  // si pct >= 88 (mostrando ANTES) → ocultar label DESPUÉS
    var HIDE_BEFORE_AT = 12;  // si pct <= 12 (mostrando DESPUÉS) → ocultar label ANTES

    function setPosition(pct) {
      pct = Math.max(0, Math.min(100, pct));
      position = pct;

      // Clip del before: cuanto mayor el pct, menos clip (más BEFORE visible a la izquierda)
      before.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      handle.style.left = pct + '%';
      handle.setAttribute('aria-valuenow', Math.round(pct));

      // Fade de labels según extremo
      if (labelBefore) labelBefore.style.opacity = pct > HIDE_BEFORE_AT ? '1' : '0';
      if (labelAfter)  labelAfter.style.opacity  = pct < HIDE_AFTER_AT  ? '1' : '0';

      if (!hasInteracted) {
        hasInteracted = true;
        if (hint) hint.style.opacity = '0';
      }
    }

    function getPercent(x) {
      var r = slider.getBoundingClientRect();
      return ((x - r.left) / r.width) * 100;
    }

    function onDown(e) {
      isDragging = true;
      slider.classList.add('is-dragging');
      e.preventDefault();
      var x = e.touches ? e.touches[0].clientX : e.clientX;
      setPosition(getPercent(x));
    }
    function onMove(e) {
      if (!isDragging) return;
      var x = e.touches ? e.touches[0].clientX : e.clientX;
      setPosition(getPercent(x));
    }
    function onUp() {
      isDragging = false;
      slider.classList.remove('is-dragging');
    }

    slider.addEventListener('mousedown', onDown);
    slider.addEventListener('touchstart', onDown, { passive: false });
    document.addEventListener('mousemove', onMove);
    document.addEventListener('touchmove', onMove, { passive: true });
    document.addEventListener('mouseup', onUp);
    document.addEventListener('touchend', onUp);

    handle.addEventListener('keydown', function (e) {
      var step = e.shiftKey ? 10 : 2;
      if (e.key === 'ArrowLeft' || e.key === 'ArrowDown')      { e.preventDefault(); setPosition(position - step); }
      else if (e.key === 'ArrowRight' || e.key === 'ArrowUp')  { e.preventDefault(); setPosition(position + step); }
      else if (e.key === 'Home')                                { e.preventDefault(); setPosition(0); }
      else if (e.key === 'End')                                 { e.preventDefault(); setPosition(100); }
    });

    setPosition(50);
    if (hint) setTimeout(function () { if (!hasInteracted) hint.classList.add('is-pulsing'); }, 1000);
  }

  document.querySelectorAll('[data-ba-slider]').forEach(initSlider);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-ba-slider]').forEach(initSlider);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Gallery
  function initGallery(gallery) {
    if (gallery.dataset.bound === 'true') return;
    gallery.dataset.bound = 'true';
    var slides = gallery.querySelectorAll('[data-hero-slide]');
    var dots = gallery.querySelectorAll('[data-hero-dot]');
    var prev = gallery.querySelector('[data-hero-prev]');
    var next = gallery.querySelector('[data-hero-next]');
    var thumbsContainer = gallery.parentElement.querySelector('.hero-product__thumbs');
    var thumbs = thumbsContainer ? thumbsContainer.querySelectorAll('[data-hero-thumb]') : [];
    if (slides.length < 2) return;
    var current = 0, total = slides.length;
    function go(idx) {
      idx = (idx + total) % total;
      slides.forEach(function (s, i) {
        s.classList.toggle('is-active', i === idx);
        if (i !== idx) s.setAttribute('aria-hidden', 'true');
        else s.removeAttribute('aria-hidden');
      });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
      current = idx;
    }
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
    var startX = 0, isTouching = false;
    gallery.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; isTouching = true; }, { passive: true });
    gallery.addEventListener('touchend', function (e) {
      if (!isTouching) return;
      var diff = e.changedTouches[0].clientX - startX;
      if (Math.abs(diff) > 50) go(current + (diff < 0 ? 1 : -1));
      isTouching = false;
    });
  }

  // Bundle selector + add to cart
  function initBundles(container) {
    if (container.dataset.bound === 'true') return;
    container.dataset.bound = 'true';

    var radios = container.querySelectorAll('[data-bundle-radio]');
    var cards = container.querySelectorAll('[data-bundle-card]');
    var addBtn = container.querySelector('[data-hero-bundles-add]');

    function formatMoney(cents) {
      var amount = cents / 100;
      var formatted = Math.round(amount).toLocaleString('es-AR');
      return '$' + formatted;
    }
    function updateCardPrice(card) { /* no-op */ }

    // Arma el payload de /cart/add.js para la tarjeta seleccionada.
    // Lo usan POR IGUAL el boton principal de esta seccion y el sticky ATC
    // (que lo recibe por el evento bundle:selected), asi las dos vias de
    // compra no pueden quedar desincronizadas nunca mas.
    function buildItems(selected) {
      var items = [];
      var upsellIds = [];
      if (!selected || !selected.value) return { items: items, upsellIds: upsellIds };
      items.push({ id: parseInt(selected.value, 10), quantity: 1 });
      var card = selected.closest('[data-bundle-card]');
      if (card) {
        card.querySelectorAll('[data-bundle-upsell].is-checked').forEach(function (up) {
          var vid = up.getAttribute('data-upsell-variant-id');
          if (!vid) return;
          var parsed = parseInt(vid, 10);
          if (!isNaN(parsed) && parsed > 0) {
            items.push({ id: parsed, quantity: 1 });
            upsellIds.push(parsed);
          }
        });
      }
      return { items: items, upsellIds: upsellIds };
    }

    // Avisa al resto de la pagina (sticky ATC) que cambio el plan elegido.
    // Regla 34: CustomEvent global, nunca acoplar el DOM de dos secciones.
    // Se llama SIEMPRE desde updateSelection(), asi que no depende del evento
    // 'change' nativo del radio -- que no se dispara cuando el comprador toca
    // la tarjeta y el JS pone .checked a mano (era la causa del bug).
    function emitBundleSelected() {
      var selected = container.querySelector('[data-bundle-radio]:checked');
      if (!selected) return;
      var card = selected.closest('[data-bundle-card]');
      var img = card ? card.querySelector('.hero-bundle-card__media img') : null;
      var payload = buildItems(selected);
      var detail = {
        variantId: selected.value,
        priceCents: parseInt(selected.getAttribute('data-price-cents'), 10) || 0,
        compareAtCents: parseInt(selected.getAttribute('data-compare-cents'), 10) || 0,
        priceText: selected.getAttribute('data-price-text') || '',
        compareText: selected.getAttribute('data-compare-text') || '',
        title: selected.getAttribute('data-bundle-title') || '',
        imageUrl: img ? img.src : '',
        items: payload.items,
        upsellIds: payload.upsellIds
      };
      // El sticky ATC es la ULTIMA seccion del template y puede inicializarse
      // despues de este emit, perdiendose el evento. Dejamos el ultimo estado
      // en window para que lo lea al arrancar.
      window.UvoraBundleState = detail;
      document.dispatchEvent(new CustomEvent('bundle:selected', { detail: detail }));
    }

    async function fetchUpsellPrices(card) {
      var upsells = card.querySelectorAll('[data-bundle-upsell][data-upsell-variant-id]');
      await Promise.all(Array.from(upsells).map(async function (up) {
        if (up.getAttribute('data-upsell-price')) return;
        var vid = up.getAttribute('data-upsell-variant-id');
        try {
          var res = await fetch('/variants/' + vid + '.js');
          if (!res.ok) return;
          var data = await res.json();
          if (data && data.price) up.setAttribute('data-upsell-price', data.price);
        } catch (e) {}
      }));
      updateCardPrice(card);
    }

    function registerBundleUpsellPairs(bundleVariantId, upsellVariantIds) {
      try {
        var pairs = JSON.parse(sessionStorage.getItem('uvora_bundle_pairs') || '[]');
        pairs = pairs.filter(function (p) { return p.bundle !== bundleVariantId; });
        if (upsellVariantIds.length > 0) {
          pairs.push({ bundle: bundleVariantId, upsells: upsellVariantIds });
        }
        sessionStorage.setItem('uvora_bundle_pairs', JSON.stringify(pairs));
      } catch (e) {}
    }

    async function enforceCartBundleUpsells(cart) {
      try {
        var pairs = JSON.parse(sessionStorage.getItem('uvora_bundle_pairs') || '[]');
        if (!pairs.length) return;
        var cartVariantIds = (cart.items || []).map(function (i) { return String(i.variant_id); });
        var toRemove = [];
        pairs.forEach(function (pair) {
          if (!cartVariantIds.includes(String(pair.bundle))) {
            pair.upsells.forEach(function (uid) {
              if (cartVariantIds.includes(String(uid))) toRemove.push(String(uid));
            });
          }
        });
        if (!toRemove.length) return;
        var updates = {};
        toRemove.forEach(function (uid) { updates[uid] = 0; });
        var res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
        if (res.ok) {
          var newCart = await res.json();
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: newCart }));
        }
      } catch (e) {}
    }

    function resetCardUpsells(card) {
      card.querySelectorAll('[data-bundle-upsell]').forEach(function (up) {
        var isAlwaysOn = up.getAttribute('data-upsell-always-on') === 'true';
        var isDefault = up.getAttribute('data-upsell-default-checked') === 'true';
        var shouldBeChecked = isAlwaysOn || isDefault;
        var cb = up.querySelector('[data-upsell-checkbox]');
        if (cb) cb.checked = shouldBeChecked;
        if (shouldBeChecked) up.classList.add('is-checked');
        else up.classList.remove('is-checked');
      });
      updateCardPrice(card);
    }

    function updateSelection() {
      cards.forEach(function (card) {
        var input = card.querySelector('[data-bundle-radio]');
        var wasSelected = card.classList.contains('is-selected');
        var isSelected = !!(input && input.checked);
        if (isSelected) {
          card.classList.add('is-selected');
          if (!wasSelected) {
            resetCardUpsells(card);
            fetchUpsellPrices(card);
          }
        } else {
          card.classList.remove('is-selected');
        }
      });
      emitBundleSelected();
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function (e) {
        if (e.target.closest('[data-bundle-upsell]')) return;
        var input = card.querySelector('[data-bundle-radio]');
        if (input && !input.disabled && !input.checked) {
          input.checked = true;
          updateSelection();
        }
      });

      card.querySelectorAll('[data-bundle-upsell]').forEach(function (up) {
        var cb = up.querySelector('[data-upsell-checkbox]');
        if (!cb) return;
        if (up.getAttribute('data-upsell-always-on') === 'true') {
          up.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); });
          return;
        }
        cb.addEventListener('change', function () {
          if (cb.checked) up.classList.add('is-checked');
          else up.classList.remove('is-checked');
          updateCardPrice(card);
          // Tildar/destildar un upsell cambia el pedido: re-avisar al sticky.
          emitBundleSelected();
        });
      });

      if (card.classList.contains('is-selected')) {
        resetCardUpsells(card);
        fetchUpsellPrices(card);
      }
    });

    radios.forEach(function (r) { r.addEventListener('change', updateSelection); });

    // Expuesto para que el sticky ATC registre los mismos pares bundle-upsell
    // que registra esta seccion (sino enforceCartBundleUpsells borra de mas).
    window.UvoraBundles = { registerPairs: registerBundleUpsellPairs };

    // Estado inicial: deja window.UvoraBundleState listo antes de que el
    // sticky ATC se inicialice.
    emitBundleSelected();

    document.addEventListener('cart:updated', function (e) {
      if (e.detail) enforceCartBundleUpsells(e.detail);
    });

    // Mensaje inline en vez de un cartel modal del navegador: el modal corta
    // la compra en seco y en mobile se siente como un error de la tienda.
    function showBundleError(msg) {
      if (!addBtn) return;
      var box = container.querySelector('[data-bundles-error]');
      if (!box) {
        box = document.createElement('p');
        box.setAttribute('data-bundles-error', '');
        box.setAttribute('role', 'alert');
        box.style.cssText = 'margin:8px 0 0;text-align:center;font-size:13px;color:var(--hb-add-bg,currentColor);';
        addBtn.parentNode.appendChild(box);
      }
      box.textContent = msg;
      box.style.display = '';
      clearTimeout(box.__t);
      box.__t = setTimeout(function () { box.style.display = 'none'; }, 5000);
    }

    async function submitBundle() {
      if (!addBtn || addBtn.hasAttribute('aria-busy')) return;

      var selected = container.querySelector('[data-bundle-radio]:checked');
      if (!selected || !selected.value) {
        showBundleError('Elegi un plan para continuar.');
        return;
      }

      var bundleVariantId = parseInt(selected.value, 10);
      var payload = buildItems(selected);

      registerBundleUpsellPairs(String(bundleVariantId), payload.upsellIds.map(String));

      addBtn.setAttribute('aria-busy', 'true');
      var txtSpan = addBtn.querySelector('.add-to-cart-text');
      var originalText = txtSpan ? txtSpan.textContent : '';
      if (txtSpan) txtSpan.textContent = 'Agregando...';

      try {
        var res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: payload.items })
        });
        if (!res.ok) { var eb = await res.json(); throw new Error(eb.description || eb.message || 'Error'); }
        var cartRes = await fetch('/cart.js');
        var cart = await cartRes.json();
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        var drawer = document.querySelector('[data-cart-drawer]');
        var overlay = document.querySelector('[data-cart-drawer-overlay]');
        if (drawer) {
          drawer.classList.add('is-open');
          if (overlay) overlay.classList.add('is-open');
          document.body.style.overflow = 'hidden';
          drawer.setAttribute('aria-hidden', 'false');
          var toggleBtn = document.querySelector('[data-cart-toggle]');
          if (toggleBtn) toggleBtn.click();
        }
        if (txtSpan) txtSpan.textContent = originalText;
      } catch (err) {
        console.error(err);
        showBundleError(err.message || 'Hubo un problema. Proba de nuevo.');
        if (txtSpan) txtSpan.textContent = originalText;
      } finally {
        addBtn.removeAttribute('aria-busy');
      }
    }

    // El boton ahora es type="submit" dentro del form de producto.
    // Interceptamos el submit para hacerlo por AJAX; stopPropagation evita que
    // otro listener de submit sobre el mismo form dispare un segundo
    // /cart/add (regla 78). Si este JS no corre, el form postea nativo y la
    // compra igual funciona (regla 60).
    var productForm = container.closest('form');
    if (productForm) {
      productForm.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopPropagation();
        submitBundle();
      });
    } else if (addBtn) {
      addBtn.addEventListener('click', function (e) {
        e.preventDefault();
        submitBundle();
      });
    }
  }

  // FAQ con auto-cierre (single-open): al abrir una, las otras se cierran
  function initFaq(list) {
    if (list.dataset.bound === 'true') return;
    list.dataset.bound = 'true';
    if (list.dataset.singleOpen !== 'true') return;
    var items = list.querySelectorAll('.hero-faq__item');
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (item.open) {
          items.forEach(function (other) { if (other !== item) other.open = false; });
        }
      });
    });
  }

  document.querySelectorAll('[data-hero-gallery]').forEach(initGallery);
  document.querySelectorAll('[data-hero-bundles]').forEach(initBundles);
  document.querySelectorAll('.hero-faq__list').forEach(initFaq);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-hero-gallery]').forEach(initGallery);
    e.target.querySelectorAll('[data-hero-bundles]').forEach(initBundles);
    e.target.querySelectorAll('.hero-faq__list').forEach(initFaq);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Gallery
  function initGallery(gallery) {
    if (gallery.dataset.bound === 'true') return;
    gallery.dataset.bound = 'true';
    var slides = gallery.querySelectorAll('[data-hero-slide]');
    var dots = gallery.querySelectorAll('[data-hero-dot]');
    var prev = gallery.querySelector('[data-hero-prev]');
    var next = gallery.querySelector('[data-hero-next]');
    var thumbsContainer = gallery.parentElement.querySelector('.hero-product__thumbs');
    var thumbs = thumbsContainer ? thumbsContainer.querySelectorAll('[data-hero-thumb]') : [];
    if (slides.length < 2) return;
    var current = 0, total = slides.length;
    function go(idx) {
      idx = (idx + total) % total;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); if (i !== idx) s.setAttribute('aria-hidden', 'true'); else s.removeAttribute('aria-hidden'); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
      current = idx;
    }
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
    var startX = 0, isTouching = false;
    gallery.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; isTouching = true; }, { passive: true });
    gallery.addEventListener('touchend', function (e) {
      if (!isTouching) return;
      var diff = e.changedTouches[0].clientX - startX;
      if (Math.abs(diff) > 50) go(current + (diff < 0 ? 1 : -1));
      isTouching = false;
    });
  }

  // Bundle selector + add to cart
  function initBundles(container) {
    if (container.dataset.bound === 'true') return;
    container.dataset.bound = 'true';

    var radios = container.querySelectorAll('[data-bundle-radio]');
    var cards = container.querySelectorAll('[data-bundle-card]');
    var addBtn = container.querySelector('[data-hero-bundles-add]');

    function updateSelection() {
      cards.forEach(function (card) {
        var input = card.querySelector('[data-bundle-radio]');
        if (input && input.checked) card.classList.add('is-selected');
        else card.classList.remove('is-selected');
      });
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function (e) {
        // El click en el label naturalmente activa el radio
        // Pero si clickea en otro lado del card, también activa
        var input = card.querySelector('[data-bundle-radio]');
        if (input && !input.disabled && !input.checked) {
          input.checked = true;
          updateSelection();
        }
      });
    });

    radios.forEach(function (r) {
      r.addEventListener('change', updateSelection);
    });

    if (addBtn) {
      addBtn.addEventListener('click', async function (e) {
        e.preventDefault();
        if (addBtn.hasAttribute('aria-busy')) return;

        var selected = container.querySelector('[data-bundle-radio]:checked');
        if (!selected) {
          alert('Elegí un plan primero');
          return;
        }
        if (!selected.value) {
          alert('El producto aún no está configurado. Asegurate que el handle del producto en los settings de la sección coincida con un producto publicado.');
          return;
        }

        var variantId = selected.value;
        addBtn.setAttribute('aria-busy', 'true');
        var txtSpan = addBtn.querySelector('.add-to-cart-text');
        var originalText = txtSpan ? txtSpan.textContent : '';
        if (txtSpan) txtSpan.textContent = 'Agregando...';

        try {
          var res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
          });
          if (!res.ok) {
            var eb = await res.json();
            throw new Error(eb.description || eb.message || 'Error');
          }
          // Trigger drawer + refresh
          var cartRes = await fetch('/cart.js');
          var cart = await cartRes.json();
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
          // Open drawer
          var drawer = document.querySelector('[data-cart-drawer]');
          var overlay = document.querySelector('[data-cart-drawer-overlay]');
          if (drawer) {
            drawer.classList.add('is-open');
            if (overlay) overlay.classList.add('is-open');
            document.body.style.overflow = 'hidden';
            drawer.setAttribute('aria-hidden', 'false');
            // Trigger refresh via cart toggle
            var toggleBtn = document.querySelector('[data-cart-toggle]');
            if (toggleBtn) toggleBtn.click();
          }
          if (txtSpan) txtSpan.textContent = originalText;
        } catch (err) {
          console.error(err);
          alert(err.message || 'Hubo un problema. Probá de nuevo.');
          if (txtSpan) txtSpan.textContent = originalText;
        } finally {
          addBtn.removeAttribute('aria-busy');
        }
      });
    }
  }

  document.querySelectorAll('[data-hero-gallery]').forEach(initGallery);
  document.querySelectorAll('[data-hero-bundles]').forEach(initBundles);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-hero-gallery]').forEach(initGallery);
    e.target.querySelectorAll('[data-hero-bundles]').forEach(initBundles);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-2"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initIngredientsCarousel(section) {
    if (section.dataset.bound === 'true') return;
    section.dataset.bound = 'true';

    var track = section.querySelector('[data-ic-track]');
    var prev = section.querySelector('[data-ic-prev]');
    var next = section.querySelector('[data-ic-next]');
    var progress = section.querySelector('[data-ic-progress]');
    if (!track) return;

    function getScrollStep() {
      var card = track.querySelector('.ingredients-carousel__card');
      if (!card) return 300;
      var style = window.getComputedStyle(track);
      var gap = parseInt(style.columnGap || style.gap || '16', 10);
      return card.offsetWidth + gap;
    }

    function updateUI() {
      var cards = track.querySelectorAll('.ingredients-carousel__card');
      var totalCards = cards.length;
      var maxScroll = track.scrollWidth - track.clientWidth;
      var current = track.scrollLeft;

      // Progreso basado en qué card está más cerca del centro del viewport
      var fillPct;
      if (totalCards > 0 && maxScroll > 0) {
        var trackRect = track.getBoundingClientRect();
        var trackCenter = trackRect.left + trackRect.width / 2;
        var closestIdx = 0;
        var closestDist = Infinity;
        cards.forEach(function (card, i) {
          var r = card.getBoundingClientRect();
          var cardCenter = r.left + r.width / 2;
          var dist = Math.abs(cardCenter - trackCenter);
          if (dist < closestDist) {
            closestDist = dist;
            closestIdx = i;
          }
        });
        // La card 0 = inicio de barra, la última = fin de barra
        fillPct = totalCards > 1
          ? (closestIdx / (totalCards - 1)) * 100
          : 100;
        // Mínimo visible para que la barra no quede en 0
        if (fillPct < 8) fillPct = 8;
      } else {
        fillPct = 100;
      }

      if (progress) progress.style.width = fillPct + '%';

      if (prev) {
        if (current <= 4) prev.setAttribute('disabled', '');
        else prev.removeAttribute('disabled');
      }
      if (next) {
        if (current >= maxScroll - 4) next.setAttribute('disabled', '');
        else next.removeAttribute('disabled');
      }
    }

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -getScrollStep(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: getScrollStep(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', updateUI, { passive: true });
    window.addEventListener('resize', updateUI);
    updateUI();
  }

  document.querySelectorAll('[data-ingredients-carousel]').forEach(initIngredientsCarousel);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-ingredients-carousel]').forEach(initIngredientsCarousel);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quiz"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initQuiz(quiz) {
    if (quiz.dataset.bound === 'true') return;
    quiz.dataset.bound = 'true';
    var steps = quiz.querySelectorAll('[data-step]');
    var results = quiz.querySelectorAll('[data-result]');
    var progress = quiz.querySelectorAll('[data-progress-step]');
    quiz.querySelectorAll('[data-quiz-answer]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.dataset.stepTarget;
        steps.forEach(function (s) { s.classList.remove('is-active'); });
        results.forEach(function (r) { r.classList.remove('is-active'); });
        if (target.indexOf('result') === 0) {
          quiz.querySelector('[data-result="' + target + '"]').classList.add('is-active');
          progress.forEach(function (p) { p.classList.add('is-complete'); });
        } else {
          var nextStep = quiz.querySelector('[data-step="' + target + '"]');
          if (nextStep) {
            nextStep.classList.add('is-active');
            progress.forEach(function (p) {
              var idx = parseInt(p.dataset.progressStep, 10);
              p.classList.toggle('is-active', idx <= parseInt(target, 10));
            });
          }
        }
      });
    });
  }
  document.querySelectorAll('[data-quiz]').forEach(initQuiz);
  document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('[data-quiz]').forEach(initQuiz); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-addtocart"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initStickyATC(bar) {
    if (bar.dataset.bound === 'true') return;
    bar.dataset.bound = 'true';

    var triggerSelector = bar.dataset.showAfter || '.hero-product';
    var triggerEl = document.querySelector(triggerSelector);
    var addBtn = bar.querySelector('[data-sticky-add]');
    var titleEl = bar.querySelector('[data-sticky-title]');
    var variantEl = bar.querySelector('[data-sticky-variant]');
    var priceEl = bar.querySelector('[data-sticky-price]');
    var priceOldEl = bar.querySelector('[data-sticky-price-old]');
    var imgEl = bar.querySelector('[data-sticky-image]');

    // Mostrar/ocultar al scroll después del trigger element
    function checkVisibility() {
      if (!triggerEl) {
        // Sin trigger: aparece después de 400px de scroll
        if (window.scrollY > 400) {
          bar.classList.add('is-visible');
          bar.setAttribute('aria-hidden', 'false');
        } else {
          bar.classList.remove('is-visible');
          bar.setAttribute('aria-hidden', 'true');
        }
        return;
      }

      var rect = triggerEl.getBoundingClientRect();
      // Aparece cuando el bottom del hero sale de la viewport
      if (rect.bottom < 0) {
        bar.classList.add('is-visible');
        bar.setAttribute('aria-hidden', 'false');
      } else {
        bar.classList.remove('is-visible');
        bar.setAttribute('aria-hidden', 'true');
      }
    }

    // Throttle scroll
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          checkVisibility();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });

    checkVisibility();

    // Pedido que va a mandar esta barra. Lo define el plan elegido en el hero
    // (evento bundle:selected). Si no hay hero en la pagina, queda en null y
    // se usa la variante renderizada en el boton.
    var stickyItems = null;
    var stickyUpsellIds = [];

    function formatMoney(cents) {
      return '$' + Math.round(cents / 100).toLocaleString('es-AR');
    }

    // Sincronizacion con el plan elegido (regla 34).
    // Antes esto leia clases internas del hero (.hero-bundle-card__price) y
    // dependia del evento 'change' del radio, que NO se dispara cuando el
    // comprador toca la tarjeta -- por eso la barra se quedaba con el plan
    // viejo a precio completo. Ahora es un contrato por evento.
    function applyBundle(d) {
      if (!d) return;

      if (d.variantId && addBtn) addBtn.setAttribute('data-variant-id', d.variantId);
      // Mantener el input del form nativo en sincronia, para que el respaldo
      // sin JS tambien postee el plan elegido y no el del arranque.
      var hidden = bar.querySelector('[data-sticky-variant-input]');
      if (hidden && d.variantId) hidden.value = d.variantId;
      stickyItems = (d.items && d.items.length) ? d.items : null;
      stickyUpsellIds = d.upsellIds || [];

      if (d.title && variantEl) variantEl.textContent = d.title;

      if (priceEl) {
        // priceText viene ya formateado por Liquid (money_without_trailing_zeros),
        // asi se ve identico al precio de la tarjeta. Los centavos son el fallback.
        if (d.priceText) priceEl.textContent = d.priceText;
        else if (d.priceCents) priceEl.textContent = formatMoney(d.priceCents);
      }

      if (priceOldEl) {
        var oldText = d.compareText || (d.compareAtCents ? formatMoney(d.compareAtCents) : '');
        if (oldText) {
          priceOldEl.textContent = oldText;
          priceOldEl.style.display = '';
        } else {
          priceOldEl.style.display = 'none';
        }
      }

      if (d.imageUrl && imgEl && imgEl.tagName === 'IMG') imgEl.src = d.imageUrl;
    }

    // Estado inicial: el hero es la primera seccion del template y ya emitio
    // el evento antes de que esta barra se inicializara, asi que lo leemos
    // del estado global que dejo guardado.
    if (window.UvoraBundleState) applyBundle(window.UvoraBundleState);

    document.addEventListener('bundle:selected', function (e) {
      applyBundle(e.detail);
    });

    // Lleva al bloque de planes (modo ancla, o cuando no hay variante conocida).
    function goToPlans() {
      var target = document.querySelector(bar.dataset.anchorTarget || '[data-hero-bundles]')
                || document.querySelector('[data-hero-bundles]');
      if (target && target.scrollIntoView) {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else {
        window.location.href = '{{ routes.cart_url }}';
      }
    }

    async function submitSticky() {
      if (!addBtn || addBtn.hasAttribute('aria-busy')) return;

      // Modo ancla: la compra la maneja la app de bundles, esta barra solo
      // lleva al selector de planes.
      if (bar.dataset.atcMode === 'anchor') { goToPlans(); return; }

      // Pedido a mandar: el mismo que armaria el boton principal del hero.
      // Si no llego ningun bundle:selected, caemos a la variante renderizada.
      var variantId = addBtn.getAttribute('data-variant-id');
      var itemsToAdd = stickyItems;
      if (!itemsToAdd) {
        if (!variantId) {
          // Sin variante conocida no hay nada que agregar: en vez de dejar
          // al comprador en un callejon sin salida, lo llevamos a los planes.
          goToPlans();
          return;
        }
        itemsToAdd = [{ id: parseInt(variantId, 10), quantity: 1 }];
      }

      addBtn.setAttribute('aria-busy', 'true');
      var longText = addBtn.querySelector('.sticky-atc__btn-text-long');
      var shortText = addBtn.querySelector('.sticky-atc__btn-text-short');
      var originalLong = longText ? longText.textContent : '';
      var originalShort = shortText ? shortText.textContent : '';
      if (longText) longText.textContent = 'Agregando…';
      if (shortText) shortText.textContent = '…';

      try {
          // Registrar los mismos pares bundle-upsell que registra el hero, para
          // que su limpieza de upsells huerfanos no borre nada de mas.
          if (variantId && window.UvoraBundles && window.UvoraBundles.registerPairs) {
            window.UvoraBundles.registerPairs(
              String(variantId),
              stickyUpsellIds.map(String)
            );
          }

          var res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({ items: itemsToAdd })
          });

          if (!res.ok) {
            var errBody = await res.json();
            throw new Error(errBody.description || errBody.message || 'Error');
          }

          // Refrescar el cart drawer
          var cartRes = await fetch('/cart.js');
          var cart = await cartRes.json();
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));

          // Abrir el cart drawer
          var drawer = document.querySelector('[data-cart-drawer]');
          var overlay = document.querySelector('[data-cart-drawer-overlay]');
          if (drawer) {
            drawer.classList.add('is-open');
            if (overlay) overlay.classList.add('is-open');
            document.body.style.overflow = 'hidden';
            drawer.setAttribute('aria-hidden', 'false');
            var toggleBtn = document.querySelector('[data-cart-toggle]');
            if (toggleBtn) toggleBtn.click();
          }

          if (longText) longText.textContent = '✓ Agregado';
          if (shortText) shortText.textContent = '✓';

          setTimeout(function () {
            if (longText) longText.textContent = originalLong;
            if (shortText) shortText.textContent = originalShort;
          }, 1500);

        } catch (err) {
          console.error(err);
          // Mensaje en el propio boton en vez de un alert que tapa la pantalla.
          if (longText) longText.textContent = 'No se pudo agregar';
          if (shortText) shortText.textContent = 'Error';
          setTimeout(function () {
            if (longText) longText.textContent = originalLong;
            if (shortText) shortText.textContent = originalShort;
          }, 2500);
        } finally {
          addBtn.removeAttribute('aria-busy');
        }
    }

    // El boton es type="submit" dentro del form nativo (modo agregar).
    // stopPropagation evita un segundo /cart/add si otro listener escucha el
    // mismo submit (regla 78). Sin JS, el form postea solo y la compra anda.
    var stickyForm = bar.querySelector('[data-sticky-form]');
    if (stickyForm) {
      stickyForm.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopPropagation();
        submitSticky();
      });
    }
    if (addBtn && !stickyForm) {
      addBtn.addEventListener('click', function (e) {
        e.preventDefault();
        submitSticky();
      });
    }
  }

  document.querySelectorAll('[data-sticky-atc]').forEach(initStickyATC);

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-sticky-atc]').forEach(initStickyATC);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
